module.exports = __webpack_public_path__ + "img/Display-Ad-Banner-Icon.ca65f45b.jpg";